import { Tooltip } from "@mui/material";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";

const VirtualChip = (data: any) => (
  <Tooltip title={data}>
    <DoNotDisturbOnIcon color="inherit" fontSize="small" />
  </Tooltip>
);

export default VirtualChip;
